import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject
} from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { finalize, Subject, takeUntil } from 'rxjs'
import { ProductGroupedService } from 'src/app/asignacion-menu/servicios-alimentos/product-grouped-services'
import { ProductService } from 'src/app/services/api/product.service'
import Swal from 'sweetalert2'
@Component({
  selector: 'app-dialog-replicar-menus',
  templateUrl: './dialog-replicar-menus.component.html',
  styleUrls: ['./dialog-replicar-menus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogReplicarMenusComponent {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  isLoading = false
  yearsToBeCopied: number[] = []
  yearsToBeApplied: number[] = []

  yearOfGroupedServicesToBeCopied: number | null = null
  yearOfGroupedServicesToBeApplied: number | null = null

  constructor (
    private readonly cdRef: ChangeDetectorRef,
    private readonly productService: ProductService,
    public dialogReplicarMenusComponentRef: MatDialogRef<DialogReplicarMenusComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      allGroupedServices: ProductGroupedService[]
    }
  ) {}

  ngOnInit (): void {
    const currentYear = new Date().getFullYear()

    // Fill years dynamically or from data as needed
    const availableServiceYears = Array.from(
      new Set(
        this.data.allGroupedServices.map(
          (groupedService: ProductGroupedService) => {
            return groupedService.yearProduct
          }
        )
      )
    ) as number[]

    this.yearsToBeCopied = availableServiceYears
    this.yearsToBeApplied = availableServiceYears

    this.yearOfGroupedServicesToBeCopied = this.yearsToBeCopied.includes(
      currentYear - 1
    )
      ? currentYear - 1
      : this.yearsToBeCopied[0]
    this.yearOfGroupedServicesToBeApplied = currentYear
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  async updateAllServices () {
    await Swal.fire({
      title: 'Advertencia',
      text: `Se copiarán los menús del año ${this.yearOfGroupedServicesToBeCopied} al año ${this.yearOfGroupedServicesToBeApplied}. Todos los Servicios que NO contengan menús serán alterados, aquellos que ya tengan, no se modificarán. ¿Deseas continuar?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e95a1a',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.isLoading = true
        this.cdRef.markForCheck()

        this.productService
          .mutationReplicateMenusFromAllGroupedServicesFromOtherYear({
            yearOfMenusToBeApplied: this.yearOfGroupedServicesToBeApplied!,
            yearOfMenusToBeCopied: this.yearOfGroupedServicesToBeCopied!
          })
          .pipe(
            takeUntil(this._unsubscribeOnDestroy$),
            finalize(() => {
              this.isLoading = false
              this.cdRef.markForCheck()
            })
          )
          .subscribe({
            next: ({
              replicateMenusFromAllGroupedServicesFromOtherYear: alteredServices
            }) => {
              Swal.fire(
                `Se replicaron ${alteredServices} menús!`,
                `Los menús del año ${this.yearOfGroupedServicesToBeCopied} han sido replicados al año ${this.yearOfGroupedServicesToBeApplied}.`,
                'success'
              ).then(() => {
                this.dialogReplicarMenusComponentRef.close({ alteredServices })
              })
            },
            error: error => {
              console.error('Error replicando menús:', error)
              Swal.fire(
                'Error',
                'Ocurrió un error al replicar los menús. Por favor, intenta nuevamente.',
                'error'
              )
            }
          })
      }
    })
  }
}
